const subscriptions = new Map<string, Set<Function>>();

export default subscriptions;
